import { ReactComponent as AttachmentPaperclip } from './icons/attachment_paperclip.svg';
import { IconButton, Tooltip } from "@mui/material";
import { useRef } from "react";
import { cv } from '../themeVars';

//import { hiddenInputStyles } from "./styles/AttachFileButton.styles";


export const AttachFileButton = (props) => {
    const fileInputRef = useRef(null);

    const onInputClick = (event) => {
        fileInputRef.current?.click();
        // Don't clear existing files - allow adding more files to existing attachments
        if (fileInputRef.current){
            fileInputRef.current.value = '';
        }
        //event.target.value = '';
    };

    return (
        <Tooltip title="Add file attachment" arrow placement="top"><span>
        <IconButton variant="secondary_icon" onClick={() => onInputClick()} disabled={props.disabled}>
            <input
                style={styles.hiddenInputStyles}
                onChange={props.onFileChange}
                //onClick={onInputClick} // React console complained with a long error about this, so input click logic was all moved to onInputClick
                type="file"
                // keep consistent with ChatScreen list
                accept={props.validFileTypes.join(",")}
                ref={fileInputRef}
                multiple
            />
            <AttachmentPaperclip style={{ color: !props.disabled ? cv('accent', "#007AFF") : cv('text-disabled', "rgba(0, 0, 0, 0.26)") }} aria-hidden="true" />
        </IconButton>
        </span></Tooltip>
    );
};

const styles = {
    hiddenInputStyles: {
        visibility: "hidden",
        position: "absolute",
        width: "1px",
        height: "1px",
        overflow: "hidden"
    }
}
